import classNames from 'classnames';
import PropTypes from "prop-types";
import React from "react";

import styles from "./CardButton.module.css";


const CardButton = ({ className, onClick, children, ...otherProps }) => {

    return (
        <button
            onClick={onClick} onKeyPress={onClick}
            className={classNames(styles.card, className)}
            {...otherProps}
        >
            {children}
        </button>
    )
}

CardButton.propTypes = {
    onClick: PropTypes.func.isRequired,
}

export default CardButton;